import { useEffect, useMemo, useState } from "react"
import { MaterialReactTable, type MRT_ColumnDef } from "material-react-table"
import { Box } from "@mui/system"
import { Checkbox, CircularProgress } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { getTokenLocal } from "../../../../../helper/utils"
import {
  setGroupProfileDetailChanged,
  setGroupProfileDetailsIsAssignedChanged,
  setIsAssignedBucketDetails,
  setSelectAllDisableCheck,
  setSelectedBucketDetails,
} from "../../../../redux/slices/groupProfileSlice"
import { setLoading } from "../../../../redux/slices/appSlice"
import { toast } from "react-toastify"
import GroupProfileAPI from "../../../../../api/groupProfile"
import MetricDetailsConformation from "../../../Modal/MetricDetailsIndividual"
import MetricDetailsSelectAllConformation from "../../../Modal/MetricDetailsSelectAll"

const groupProfileAPI = new GroupProfileAPI()

const GroupMetricTable = () => {
  const dispatch = useDispatch()
  const token: any = getTokenLocal()
  const [opened, SetOpened] = useState(false)
  const [openedSelectAll, SetOpenedSelectAll] = useState(false)
  // const [AssignedBucketDetails, setAssignedBucketDetails] = useState({})
  const [isCheckedLoading, setIsCheckedLoading] = useState("")

  const selectedGroupSk = useSelector((state: any) => {
    return state.groupProfile?.selectedGroupSk
  })

  const selectedBucketDetails = useSelector((state: any) => {
    return state.groupProfile?.selectedBucketDetails
  })

  const groupProfileDetails = useSelector((state: any) => {
    return state.groupProfile?.groupProfileDetails
  })

  const selectAllDisableCheck = useSelector((state: any) => {
    return state.groupProfile?.selectAllDisableCheck
  })
  let selectData: any = {}
  let metrics: any = []
  let updatedmetrics: any = []
  let disableArray: any = []

  const headersToCapsLock = ["Cytd", "Py", "pytd", "ttm"]

  const headersToChange = ["percent"]

  const capitalizeMatchingWord = (sentence: string) => {
    // Split the sentence into words
    const words = sentence.split(/\s+/)
    // Iterate over each word in the sentence
    const capitalizedWords = words.map((word) => {
      // Check if the word exists in the headersToCapsLock array
      const matchIndex = headersToCapsLock.findIndex(
        (header: any) => header.toLowerCase() === word.toLowerCase(),
      )

      const matchIndex2 = headersToChange.findIndex(
        (header: any) => header.toLowerCase() === word.toLowerCase(),
      )

      // If the word exists in headersToCapsLock, capitalize it
      if (matchIndex !== -1) {
        return word.toUpperCase()
      }

      if (matchIndex2 !== -1) {
        return "%"
      }

      // Otherwise, return the word as is
      return word
    })
    // Join the words back into a sentence
    return capitalizedWords.join(" ")
  }

  const AssignHandler = async (data: any, index: any, isAssignedd: any) => {
    dispatch(setLoading(true))

    if (token) {
      const result = await groupProfileAPI.postMetricAssigned(token, data)

      selectedBucketDetails?.metrics?.forEach((ele: any) => {
        if (ele.isAssigned === true) {
          disableArray.push(ele.isAssigned)
        }
      })

      if (selectedBucketDetails?.metrics[index].isAssigned === false) {
        disableArray.push(!selectedBucketDetails?.metrics[index].isAssigned)
      }

      if (result?.data?.status_code != 200) {
        toast.error(result?.data?.display_message)
      } else {
        toast.success(result?.data?.display_message)
        dispatch(
          setGroupProfileDetailsIsAssignedChanged({
            index,
            checkValue: isAssignedd,
          }),
        )

        if (selectedBucketDetails?.metrics.length === disableArray.length) {
          console.log("length", selectedBucketDetails?.metrics.length)
          console.log("length", disableArray.length)
          dispatch(setSelectAllDisableCheck(true))
        }
      }

      dispatch(setLoading(false))
      setIsCheckedLoading("")

      return result?.data?.status_code
    } else {
      toast.error(
        "There has been some localStorage Error, Please Logout and Login Again.",
      )
      dispatch(setLoading(false))
    }
    dispatch(setLoading(false))
  }

  const RemoveAssignHandler = async (
    data: any,
    index: any,
    isAssigned: any,
  ) => {
    dispatch(setLoading(true))
    dispatch(setSelectAllDisableCheck(false))

    if (token) {
      const result = await groupProfileAPI.removeAssigned(token, data)

      if (result?.data?.status_code != 200) {
        toast.error(result?.data?.display_message)
      } else {
        toast.success(result?.data?.display_message)
        //dispatch(setSelectAllDisableCheck(false))
        dispatch(
          setGroupProfileDetailsIsAssignedChanged({
            index,
            checkValue: isAssigned,
          }),
        )
      }

      dispatch(setLoading(false))
      setIsCheckedLoading("")

      return result?.data?.status_code
    } else {
      toast.error(
        "There has been some localStorage Error, Please Logout and Login Again.",
      )
    }
    dispatch(setLoading(false))
  }

  const CheckAssignedHandler = (
    isAssigned: any,
    AssignedData: any,
    RemoveData: any,
    index: any,
  ) => {
    console.log("AssignedData", AssignedData)
    if (isAssigned === true) {
      AssignHandler(AssignedData, index, isAssigned)
    } else {
      RemoveAssignHandler(RemoveData, index, isAssigned)
    }
  }
  const columns = useMemo<MRT_ColumnDef<any>[]>(
    //column definitions...

    () => {
      let temp: MRT_ColumnDef<any>[] = [
        {
          accessorKey: "metric_name",
          header: "Metric Name",
          Header: ({ column }) => (
            <Box
              sx={{
                fontSize: "14px",
                color: "#000",
                maxWidth: "220px",
                minHeight: "40px",
                display: "flex",
                padding: "0px",
              }}
            >
              <div
                style={{
                  width: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "",
                  marginRight: "20px",
                }}
              >
                <Checkbox
                  checked={selectAllDisableCheck}
                  onClick={() => {
                    SetOpenedSelectAll(true)
                  }}
                  disabled={selectAllDisableCheck}
                />
                {column.columnDef.header}
              </div>
            </Box>
          ),

          Cell: ({ row, renderedCellValue }) => (
            <Box
              sx={{
                fontSize: "14px",
                color: "#3C77EF",
                maxWidth: "220px",
                minHeight: "40px",
                display: "flex",
              }}
            >
              {isCheckedLoading === row.original.index ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.8rem",
                  }}
                >
                  <CircularProgress size={25} />
                </Box>
              ) : (
                <Checkbox
                  checked={row.original.isAssigned}
                  onClick={() => {
                    setIsCheckedLoading(row?.original?.index)
                    CheckAssignedHandler(
                      !row.original.isAssigned,
                      {
                        groups: [selectedGroupSk],
                        metrics: [
                          {
                            metric_bucket_id:
                              selectedBucketDetails?.metric_bucket_id,
                            metric_id: row.original.metric_id,
                          },
                        ],
                      },
                      {
                        group_sk: selectedGroupSk,
                        metric_id: row.original.metric_id,
                      },
                      row.original.index,
                    )
                    dispatch(
                      setIsAssignedBucketDetails({
                        index: row.original.index,
                        checkValue: !row.original.isAssigned,
                      }),
                    )
                  }}
                />
              )}
              <div
                style={{
                  width: "200px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div> {renderedCellValue}</div>
              </div>
            </Box>
          ),
        },
      ]
      selectedBucketDetails?.metrics?.[0]?.columns?.forEach((ele: any) => {
        temp.push({
          header: capitalizeMatchingWord(ele?.column_id.replace(/_+/g, " ")),
          accessorKey: ele?.column_id,
          Header: ({ column, header }) =>
            capitalizeMatchingWord(column.columnDef.header),
          Cell: ({ row, renderedCellValue }) => (
            <Box sx={{ fontSize: "14px" }}>{renderedCellValue}</Box>
          ),
          muiTableBodyCellProps: {
            align: "center",
          },
          muiTableHeadCellProps: {
            align: "center",
          },
        })
      })
      return temp
    },

    [selectedBucketDetails, selectAllDisableCheck, isCheckedLoading],
    //end
  )
  const data = useMemo(() => {
    let temp: any = []
    selectedBucketDetails?.metrics?.forEach((ele: any, index: any) => {
      let obj: any = {
        metric_name: ele.metric_name,
        isAssigned: ele.isAssigned,
        metric_id: ele.metric_id,
        index: index,
      }
      ele?.columns?.forEach((item: any) => {
        obj[item.column_id] =
          item.column_datatype === null
            ? "N/A"
            : item.column_datatype === ""
            ? "N/A"
            : item.column_datatype
      })

      temp.push(obj)
    })
    return temp
  }, [selectedBucketDetails])

  return (
    <>
      <MaterialReactTable
        columns={columns}
        data={data}
        initialState={{
          columnPinning: { left: ["metric_name"] },
        }}
        enableColumnActions={false}
        enableColumnFilters={false}
        enablePagination={false}
        enableSorting={false}
        enableBottomToolbar={false}
        enableTopToolbar={false}
        enableStickyHeader
        muiTableBodyRowProps={{ hover: false }}
        muiTableContainerProps={{
          sx: {
            // flex: 1,
            // overflowY: "scroll",
            // border: "1px solid blue",
            // margin: "0 !important",
            // padding: "0 !important",
            height: "60vh",
            backgroundColor: "#F8F9FA",
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            margin: "0px",
            maxHeight: "20px",
            backgroundColor: "#F7F7F7",
            color: "#000",
            fontSize: "13px",
            boxShadow: " #00000022 1.95px  0px 2.6px",
            textTransform: "capitalize",
            borderLeft: "1px solid #E4E4E4",
            padding: "10px",
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            fontSize: "14px",
            borderLeft: "1px solid #E4E4E4",
            borderBottom: "1px solid #00000022",
            boxShadow: "#00000022 1.95px 0px 2.6px",
            //backgroundColor: "#FFFFFF",
            padding: "10px",
          },
        }}
      />
      {/* <MetricDetailsConformation
        opened={opened}
        handleConfimClose={handleConfimClose}
        checkedData={checkedData}
        AssignedBucketDetails={AssignedBucketDetails}
      /> */}
      <MetricDetailsSelectAllConformation
        openedSelectAll={openedSelectAll}
        handleSelectAllConfimClose={SetOpenedSelectAll}
      />
    </>
  )
}

export default GroupMetricTable
